var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tag",class:_vm.isSelected ? 'tag--selected' : ''},[_vm._v(_vm._s(_vm.tag))])}
var staticRenderFns = []

export { render, staticRenderFns }